<template>
    <div class="type-box">
        <div class="c-que-type xy-between" v-if="mode === 'edit'">
            <el-input
                v-model="boxData.Content"
                @blur="changeName"
                placeholder="新题型名称"
            ></el-input>
            <div class="xy-center auto-grow jf-end" :id="chooseQueTypeId">
                <slot name="chooseQueTypeFront"></slot>
                <el-tooltip effect="dark" :content="tp.toolTip" placement="top"
                            v-for="(tp, index) in chooseQueType"
                            :key="'tp-' + index">
                    <span
                        class="c-256CF4 pointer no-wrap"
                        style="margin-left: 15px"
                        @click="
                        nowChoose = tp.label;
                        dialogVisible = true;
                    ">{{ tp.label }}</span>
                </el-tooltip>

            </div>
        </div>
        <div class="que-box" :key="keyIndex">
            <div v-for="(item, index) in boxData.RandomSubjectList" :key="(item.RandomTypeId || item._uuid) + 'container'">
                <question-rule
                    :key="(item.RandomTypeId || item._uuid)"
                    :rule="item"
                    :random-score.sync="randomScore"
                    @goAhead="ruleGoAhead(item, index)"
                    @goBehind="ruleGoBehind(item, index)"
                    @del="ruleDel(index)"
                ></question-rule>
            </div>
            <div
                v-for="(item, index) in boxData.SubjectList"
                :key="item.uuid"
                class="xy-between al-start"
            >
                <question-item
                    :qIndex="index"
                    :data="item"
                    style="margin-bottom: 30px"
                ></question-item>
                <div class="edit-que yx-center jf-start al-end no-shrink">
                    <div class="xy-center score">
                        <el-input v-model.number="item.Score"></el-input>
                        <span class="font-size18"> 分</span>
                    </div>
                    <div class="icon xy-center jf-start" v-if="mode === 'edit'">
                        <el-popconfirm
                            title="确定删除当前试题吗？"
                            @confirm="deleteQue(index)"
                        >
                            <i class="iconfont" slot="reference">&#xe6b9;</i>
                        </el-popconfirm>

                        <i class="iconfont" @click="goBehind(item, index)"
                            >&#xe6ba;</i
                        >
                        <i class="iconfont" @click="goAhead(item, index)"
                            >&#xe6ba;</i
                        >
                        <i
                            class="iconfont"
                            @click="editQue(item, index)"
                            >&#xe6bb;</i
                        >
                    </div>
                </div>
            </div>
        </div>
        <transition name="dialog-fade">
            <el-dialog
                v-if="dialogVisible"
                :title="nowChoose"
                :visible="true"
                :width="
                ['随机抽题', '随机组卷'].includes(nowChoose) ? '40%' : '72%'
            "
                append-to-body
                :close-on-click-modal="false"
                @close="dialogVisible = false"
                :lock-scroll="false"
            >
                <div :key="version">
                    <organization-sampling
                        ref="oSam"
                        v-if="nowChoose === '机构抽题'"
                    ></organization-sampling>
                    <system-sampling
                        ref="sSam"
                        v-if="nowChoose === '系统抽题'"
                    ></system-sampling>
                    <random-questions
                        ref="rData"
                        :now-choose="nowChoose"
                        @dis-btn="
                        (val) => {
                            isDisable = val;
                        }
                    "
                        v-if="nowChoose === '随机抽题' || nowChoose === '随机组卷'"
                    ></random-questions>
                    <div v-if="nowChoose === '手工增题'">
                        <div class="xy-center jf-start" style="margin-bottom: 20px">
                            <div class="form-item xy-center">
                                <div class="name">
                                    题型:
                                </div>
                                <el-select v-model="addQueType" placeholder="请选择">
                                    <el-option
                                        v-for="item in queTypeData"
                                        :key="item.value"
                                        :label="item.name"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="form-item xy-center">
                                <div class="name">试题难度:</div>
                                <el-select
                                    v-model="addQueDifficulty"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="item in difficultyData"
                                        :key="item.value"
                                        :label="item.name"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <add-que-box
                            ref="newAdd"
                            :que-type="addQueType"
                            :is-new="true"
                        ></add-que-box>
                    </div>
                </div>
                <span slot="footer" class="xy-center">
                <div v-if="['随机抽题', '随机组卷'].includes(nowChoose)">
                    <el-button
                        :disabled="isDisable"
                        :loading="isLoading"
                        @click="addQueToPaper"
                        type="primary"
                    >确认添加</el-button
                    >
                    <el-button @click="dialogVisible = false">取消</el-button>
                </div>
                <el-button v-else @click="addQueToPaper" type="primary"
                           :loading="isLoading"
                >添加所选试题到题型</el-button
                >
            </span>
            </el-dialog>
        </transition>
        <!-- 试题编辑 -->
        <transition name="dialog-fade">
            <el-dialog
                title="试题编辑"
                v-if="editVisible"
                visible
                width="50%"
                append-to-body
                :lock-scroll="false"
                @close="editVisible = false"
            >
                <add-que-box
                    ref="editBox"
                    :edit-que-data="activeQue"
                    :que-type="activeQue.SubjectType"
                ></add-que-box>
                <span slot="footer" class="xy-center">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="editConfirm">确 定</el-button>
            </span>
            </el-dialog>
        </transition>

    </div>
</template>

<script>
import AddQueBox from "./AddQueBox.vue";
import OrganizationSampling from "./chooseType/OrganizationSampling.vue";
import RandomQuestions from "./chooseType/RandomQuestions.vue";
import SystemSampling from "./chooseType/SystemSampling.vue";
import QuestionItem from "./QuestionItem.vue";
import { CommonPage } from "@/mixins/commonData";
import { updateQue } from "@/api/manage.js";
import QuestionHelp from "@/mixins/questionHelp";
import { uuid } from "@/utils";
import QuestionRule from "@/components/manager/resource/QuestionRule";
import { SubjectType } from "@/kernel";
import { getTypeBox } from "./chooseType/config";
export default {
    mixins: [CommonPage, QuestionHelp],
    inject: ["organClass"],
    components: {
        QuestionRule,
        OrganizationSampling,
        SystemSampling,
        RandomQuestions,
        QuestionItem,
        AddQueBox
    },
    props: {
        boxData: {
            type: Object,
            default: null
        },
        paperEdit: {
            type: Boolean,
            default: false
        },
        defaultClassId: { // 新建试题默认分类
            type: Number,
            default: null
        },
        defaultUseType: { // 新建试题默认用途
            type: Number,
            default: null
        },
        chooseQueTypeId: {
            type: String
        },
        // 当前模式，编辑和纯展示模式
        mode: {
            type: String,
            default: "edit" // edit or spread
        },
    },
    computed: {},
    data (vm) {
        return {
            chooseQueType: getTypeBox(),
            nowChoose: "",
            isDisable: false,
            dialogVisible: false,
            editVisible: false,
            version: 0,
            addQueType: 5,
            addQueDifficulty: 2, // 手工增题难度
            activeQue: {},
            keyIndex: 0,
            flag: {
                loading: false
            },
            randomScore: 0,
            isLoading: false
        };
    },
    watch: {
        dialogVisible(dialogVisible) {
            if (dialogVisible) {
                this.version++;
            }
        },
        "boxData.SubScore"(val) {
            console.log(val, "value");
            // console.log("val:", val);
            this.boxData.SubjectList.forEach((item) => {
                item.Score = val;
            });
            this.randomScore = val;
            this.boxData.RandomSubjectList?.forEach(item => {
                item.SubScore = val
            })
        },
        boxData(boxData) {
            boxData.SubjectList.forEach((que) => this.findRightAnswer(que));
        }
    },
    created() {
        console.log(this.boxData, "boxData")
        this.boxData.SubjectList.forEach((que) => this.findRightAnswer(que));
        if (this.paperEdit && this.boxData.RandomSubjectList && this.boxData.RandomSubjectList[0]) {
            this.randomScore = this.boxData.RandomSubjectList[0].SubScore;
        }
    },
    methods: {
        changeName() {},
        editQue(item, index) {
            this.activeQue = item;
            this.activeQue._index = index
            this.editVisible = true;
        },
        deleteQue(ind) {
            const clickType = this.boxData.SubjectList;
            clickType.splice(ind, 1);
            this.$message.success("已删除此题");
            // console.log("clickType:", clickType);
        },
        async addQueToPaper() {
            const typeName = {
                1: "单选题",
                2: "多选题",
                3: "填空题",
                4: "判断题",
                5: "问答题"
            }
            if (["机构抽题", "随机抽题", "系统抽题"].includes(this.nowChoose)) {
                const queArr =
                    this.nowChoose === "机构抽题"
                        ? this.$refs.oSam.getQuestionList()
                        : this.nowChoose === "系统抽题"
                            ? await this.$refs.sSam.getSelectQuestion().catch(e => {
                                this.isLoading = false
                            })
                            : this.$refs.rData.resultList;
                queArr.forEach((item) => {
                    this.findRightAnswer(item)
                    item.uuid = uuid(5)
                });
                this.boxData.SubjectList.push(...queArr);
                // console.log("queArr:", queArr);
                if (this.boxData.Content === "新题型" && queArr.length > 0) {
                    this.boxData.Content = typeName[queArr[0].SubjectType]
                }
            }
            if (this.nowChoose === "手工增题") {
                const queArr = Object.assign({}, this.$refs.newAdd.queData);
                let msg = this.verifyQues(queArr)
                if (msg) {
                    this.$message.warning(msg)
                    return
                }
                if (queArr.SubjectType === 2) {
                    queArr.Answer = queArr.Answer.sort().join(",");
                }
                if (this.boxData.Content === "新题型") {
                    this.boxData.Content = typeName[queArr.SubjectType]
                }
                this.boxData.SubjectList.push({
                    ...queArr,
                    Score: "",
                    RankNum: this.boxData.SubjectList.length + 1,
                    Hardlevel: this.addQueDifficulty,
                    uuid: uuid(5),
                    ClassId: this.defaultClassId,
                    UseType: this.defaultUseType
                });
            }

            if (this.nowChoose === "随机组卷") {
                if (this.$refs.rData.selectQueCount === "") {
                    this.$message("请选择试题数量")
                    return;
                }
                if (this.boxData.RandomSubjectList == null) {
                    this.$set(this.boxData, "RandomSubjectList", [])
                }
                let rule = this.$refs.rData.getRule()
                rule.RankNum = this.boxData.RandomSubjectList.length + 1
                rule.SubScore = this.randomScore
                let msg = this.validQueRule(rule)
                if (msg) {
                    this.$message.warning(msg)
                    return
                }
                this.boxData.RandomSubjectList.push(rule)
            }
            this.dialogVisible = false;
        },
        // 验证试题规则
        validQueRule(rule) {
            let msg;
            this.boxData.RandomSubjectList.some(item => {
                // 分类是否一致
                let classSame = rule.RoleClassId === item.RoleClassId
                // 题型是否一致
                let ruleSubjectType = rule.RoleSubjectTypeId === item.RoleSubjectTypeId
                // 难度是否一致
                let ruleDifficulty = rule.RoleHardlevel === item.RoleHardlevel
                // 用途是否一致
                let ruleUseType = rule.RoleUseType === item.RoleUseType
                if (classSame && ruleSubjectType && ruleDifficulty && ruleUseType) {
                    msg = "试题规则不能重复"
                    return true
                }
                // 数据为全部时，其他数据不能选择
                function noAllnoData(prototype, name) {
                    if (rule[prototype] !== "" && parseInt(item[prototype] || 0) === 0) {
                        return `当${name}为全部时，其他${name}不能选择`
                    }
                    if (rule[prototype] === "" && parseInt(item[prototype] || 0) !== 0) {
                        return `当选择了${name}时，其他${name}不能选择全部`
                    }
                }
                msg = noAllnoData("RoleClassId", "所属分类")
                if (msg) return true
                msg = noAllnoData("RoleSubjectTypeId", "题型")
                if (msg) return true
                msg = noAllnoData("RoleHardlevel", "试题难度")
                if (msg) return true
                msg = noAllnoData("RoleUseType", "用途")
                if (msg) return true
            })
            if (msg) {
                return msg;
            }
        },
        findRightAnswer(queData) {
            if (!queData.AnswerList) return;
            const arr = queData.AnswerList.filter(
                (item) => item.IsRight === 1
            ).map((item) => String.fromCharCode(64 + item.RankNum));
            // console.log("arr:", arr);
            if (queData.SubjectType === 1 || queData.SubjectType === 4) {
                queData.Answer = arr.join("");
            } else if (queData.SubjectType === 2) {
                queData.Answer = arr;
            }
        },
        goBehind(item, index) {
            const qIndex = index;
            // console.log("qIndex:", qIndex);
            // const arr = this.boxData.SubjectList;
            if (qIndex === this.boxData.SubjectList.length - 1) {
                this.$message.warning("已经是最后一题了");
                return;
            }
            const lastPositionQ = this.boxData.SubjectList[qIndex + 1];
            // console.log("lastPositionQ:", lastPositionQ);
            this.boxData.SubjectList[qIndex + 1] = {
                ...item,
                RankNum: qIndex + 2
            };
            this.boxData.SubjectList[qIndex] = {
                ...lastPositionQ,
                RankNum: qIndex + 1
            };
            this.keyIndex += 1;
            this.boxData.SubjectList = Array.from(this.boxData.SubjectList)
            // console.log("boxData:", this.boxData.SubjectList);
        },
        goAhead(item, index) {
            const qIndex = index;
            if (qIndex === 0) {
                this.$message.warning("已经是第一题了");
                return;
            }
            const aheadPositionQ = this.boxData.SubjectList[qIndex - 1];
            this.boxData.SubjectList[qIndex - 1] = {
                ...item,
                RankNum: qIndex
            };
            this.boxData.SubjectList[qIndex] = {
                ...aheadPositionQ,
                RankNum: qIndex + 1
            };
            this.keyIndex += 1;
            this.boxData.SubjectList = Array.from(this.boxData.SubjectList)
            // console.log("boxData:", this.boxData.SubjectList);
        },
        // 组卷规则向上移动
        ruleGoAhead(item, index) {
            const qIndex = index;
            if (qIndex === 0) {
                this.$message.warning("已经是第一个规则了");
                return;
            }
            const aheadPositionQ = this.boxData.RandomSubjectList[qIndex - 1];
            item.RankNum = qIndex
            aheadPositionQ.RankNum = qIndex + 1
            this.boxData.RandomSubjectList.splice(qIndex - 1, 1, item)
            this.boxData.RandomSubjectList.splice(qIndex, 1, aheadPositionQ)
            this.keyIndex += 1;
        },
        // 规则向下移动
        ruleGoBehind(item, index) {
            const qIndex = index;
            const randomList = this.boxData.RandomSubjectList
            // console.log("qIndex:", qIndex);
            // const arr = this.boxData.SubjectList;
            if (qIndex === randomList.length - 1) {
                this.$message.warning("已经是最后一个规则了");
                return;
            }
            const lastPositionQ = randomList[qIndex + 1];
            item.RankNum = qIndex + 2
            lastPositionQ.RankNum = qIndex + 1
            this.boxData.RandomSubjectList.splice(qIndex + 1, 1, item)
            this.boxData.RandomSubjectList.splice(qIndex, 1, lastPositionQ)
            this.keyIndex += 1;
        },
        // 删除规则
        ruleDel(index) {
            this.boxData.RandomSubjectList.splice(index, 1)
        },
        editConfirm() {
            const updateItem = () => {
                let editItem = this.$refs.editBox.queData
                editItem.SubjectName = editItem.Content;
                editItem.uuid = uuid(5)
                if (editItem.SubjectType === SubjectType.multiple && Array.isArray(editItem.Answer)) {
                    editItem.Answer = editItem.Answer.join("、")
                }
                this.boxData.SubjectList.splice(editItem._index, 1, editItem)
                return editItem;
            }

            let editItem = updateItem()
            this.$forceUpdate()
            if (editItem.SubjectId) {
                this.flagPromise([
                    updateQue({
                        examSubjectModel: JSON.stringify(editItem)
                    })
                ]).then(([res]) => {
                    console.log("试题更新成功");
                });
            }
            this.editVisible = false;
        }
    }
};
</script>

<style lang="less" scoped>
.type-box {
    .c-que-type {
        // width: 850px;
        height: 60px;
        padding: 10px 30px;
        box-sizing: border-box;
        background: #f4f5f6;
        .el-input {
            width: 150px;
            height: 40px;
            border-radius: 4px;
            input {
                height: 40px;
            }
        }
    }
    .que-box {
        min-height: 100px;
        border: 1px solid #e5e8ec;
        padding: 30px 30px 40px 40px;
        .edit-que::v-deep {
            margin-left: 20px;
            .score {
                margin-bottom: 28px;
                .el-input {
                    width: 50px;
                    height: 28px;
                    border-radius: 2px;
                    margin-right: 10px;
                    input {
                        height: 28px;
                    }
                }
            }
            .icon {
                i {
                    color: #256cf4;
                    font-size: 15px;
                    margin-left: 10px;
                    cursor: pointer;
                }
                i:nth-of-type(2) {
                    display: inline-block;
                    transform: rotate(180deg);
                    margin-top: -3px;
                }
            }
        }
    }
}
.form-item {
    margin-right: 50px;
    .name {
        white-space: nowrap;
        width: 5em;
        font-size: 16px;
        text-align: right;
        padding-right: 5px;
        box-sizing: border-box;
        margin-right: 7px;
    }
}
</style>
